import { IconButton, Menu } from '@material-ui/core';
import { MenuProps } from '@material-ui/core/Menu';
import { WithStyles } from 'decorators/withStyles';
import { MdiReactIconComponentType } from 'mdi-react';
import MoreHorizIcon from 'mdi-react/MoreHorizIcon';
import * as React from 'react';

import OptionItem from './OptionItem';

export interface IOption {
  text: string;
  icon?: MdiReactIconComponentType;
  handler: (params?: any) => void;
}

interface IState {
  targetElem?: HTMLElement;
  openMenu?: boolean;
}

interface IProps extends Partial<MenuProps> {
  classes?: any;
  options: IOption[];
  object?: any;
}

@WithStyles(() => ({
  buttonMenu: {
    height: '34px',
    width: '34px',
    border: '1px solid #D9D9D9',
    borderRadius: '4px',
    backgroundColor: '#F3F3F3'
  },
  buttonIcon: {
    width: '100%',
    height: '100%',
    padding: 0,
    borderRadius: '0 !important',
    color: '#596375'
  }
}))
export default class DropdownMenu extends React.PureComponent<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { openMenu: false };
  }

  handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ targetElem: event.currentTarget, openMenu: true });
  };

  handleClose = () => {
    this.setState({ targetElem: null, openMenu: false });
  };

  handleClick = (option: IOption) => {
    const { object } = this.props;
    this.handleClose();
    option.handler(object);
  };

  render() {
    const { targetElem } = this.state;
    const { options, classes, ...menuProps } = this.props;

    return (
      <div className={classes.buttonMenu}>
        <IconButton className={classes.buttonIcon} onClick={this.handleOpen} color="inherit">
          <MoreHorizIcon />
        </IconButton>

        <Menu {...menuProps} anchorEl={targetElem} open={!!targetElem} onClose={this.handleClose}>
          {options.map(option => (
            <OptionItem key={option.text} option={option} onClick={this.handleClick} />
          ))}
        </Menu>
      </div>
    );
  }
}
